import { unparse } from 'papaparse';

import {
  getImportResolutionPlaybook,
  type ImportActionRowContext,
} from './import-resolution-playbook';

export function downloadImportIssuesCsv(
  rows: ImportActionRowContext[],
  filename = 'bulk-import-issues.csv',
): void {
  if (rows.length === 0) return;

  const data = rows.map((row) => {
    const playbook = getImportResolutionPlaybook(row.manualResolutionKey);
    return {
      parent_email: row.parentEmail,
      parent_first_name: row.parentFirstName ?? '',
      parent_last_name: row.parentLastName ?? '',
      student_first_name: row.studentFirstName,
      student_last_name: row.studentLastName,
      row_hint: row.rowHint ?? '',
      kind: row.kind,
      resolution_reason: row.failureReason ?? row.reason,
      success: row.success,
      manual_steps: playbook.manualSteps.join(' '),
      parent_id: row.parentId ?? '',
      created_student_id: row.createdStudentId ?? '',
      existing_student_id: row.existingStudentId ?? '',
    };
  });

  const csv = unparse(data);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 100);
}
